import { gql } from "@apollo/client";

export const yearsQuery = gql`
  query {
    rv_years
  }
`;
